import { useLayoutEffect, useRef, FunctionComponent } from 'react'

import Header from 'components/layout/Header'

const ResizeHeader: FunctionComponent<ResizeHeaderProps> = ({
  height,
  handleSetFreeTrialHeight,
  headerProps,
  setLayoutHeaderHeight
}: ResizeHeaderProps) => {
  const headerRef = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (headerRef.current !== null) setLayoutHeaderHeight(headerRef.current.clientHeight)
  }, [])

  useLayoutEffect(() => {
    handleSetFreeTrialHeight(height)
    setLayoutHeaderHeight(height)
  }, [height, handleSetFreeTrialHeight, setLayoutHeaderHeight])

  return (
    <div ref={headerRef}>
      <Header {...{ ...headerProps }} />
    </div>
  )
}

interface ResizeHeaderProps {
  height: number
  handleSetFreeTrialHeight: (value: number) => void
  headerProps: any
  setLayoutHeaderHeight: (value: number) => void
}

export default ResizeHeader
